module.exports = __webpack_public_path__ + "media/1x1/mm-8d6d26bc.svg";